import { render } from "./ilkBor.vue?vue&type=template&id=b5a3609e"
import script from "./ilkBor.vue?vue&type=script&lang=js"
export * from "./ilkBor.vue?vue&type=script&lang=js"

import "./ilkBor.vue?vue&type=style&index=0&id=b5a3609e&lang=css"

import exportComponent from "D:\\projects\\vue\\e-justice-sud-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__